import React, { useEffect } from 'react';
import SelectAccount from './components/SelectAccount';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';

import { fetchAccounts } from './actions/getAccounts';
import { actions as reduxActions } from './reducers';
import styles from './styles';
import SubscriptionsHeader from './components/SubscriptionsHeader';
import { fetchSubscriptions } from './actions/getSubscriptions';
import Subscriptions from './components/Subscriptions';
import Filters from './components/Filters';
import { CircularProgress } from '@material-ui/core';

const SubscriptionsImproved = ({
  classes,
  resetSubscriptions,
  fetchAccounts,
  clientId,
  selectedAccount,
  fetchSubscriptions,
  isLoading,
  refresh,
  setRefresh
}) => {
  useEffect(() => {
    fetchAccounts(clientId);
    return resetSubscriptions;
    // eslint-disable-next-line
  }, [clientId]);

  useEffect(() => {
    if (Object.keys(selectedAccount).length > 0) {
      fetchSubscriptions({
        selectedAccount,
        clientId
      });
    }
    // eslint-disable-next-line
  }, [selectedAccount, clientId]);

  useEffect(() => {
    if (refresh) {
      if (Object.keys(selectedAccount).length > 0) {
        fetchSubscriptions({
          selectedAccount,
          clientId
        });

        setRefresh(false);
      }
    }
    // eslint-disable-next-line
  }, [refresh]);

  return (
    <>
      <div className={classes.root}>
        {isLoading && (
          <div className={classes.loaderOverlay}>
            <CircularProgress />
          </div>
        )}
        <SelectAccount />
        <SubscriptionsHeader />
        <Filters />
        <Subscriptions />
      </div>
    </>
  );
};

const mapStatesToProps = ({ selectClient, subscriptionsImproved, loader }) => {
  return {
    clientId: selectClient.selectedClient.id,
    selectedAccount: subscriptionsImproved.selectedAccount,
    isLoading: loader.isSpinVisible,
    refresh: subscriptionsImproved.refresh
  };
};

const mapDispatchToProps = {
  resetSubscriptions: reduxActions.resetSubscriptions,
  fetchAccounts,
  fetchSubscriptions,
  setRefresh: reduxActions.setRefresh
};

export default flowRight(
  connect(mapStatesToProps, mapDispatchToProps),
  withStyles(styles)
)(SubscriptionsImproved);
